import React from 'react';
import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';
import moment from 'moment';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
// import { ucwords, numberWithCommas } from '../helper';
import { ucwords, numberWithCommas } from 'helper';

function BusinessInformation({ data, handleAddRemarks, isLoading, remarks }) {
  const details = get(data, 'attributes.details') || {};
  const permissions = getJson('permissions');
  const { quantity_matrix, ...detail } = details;

  return (
    <div className="p-3">
      <table className="transaction-table table table-borderless table-sm mb-1">
        <tbody>
          {
            (get(remarks, 'attributes.transaction_type') === "RETIREMENT" &&
            get(remarks, 'included.bplsRetirements.attributes.is_full_retirement')
          ) ? (
            <React.Fragment>
              <tr className="d-flex">
                <td width="350">
                  <span className="title" style={{ fontSize: '16px' }}>
                    BUSINESS CLOSURE INFORMATION
                  </span>
                </td>
              </tr>
              <tr>
                <td className="text-dark" width="250">
                  Retirement Reason
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>{get(remarks, 'included.bplsRetirements.attributes.closure_reason') || '-'}</b>
                </td>
              </tr>
              <tr>
                <td className="text-dark" width="250">
                  Actual Closure Date
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>{get(remarks, 'included.bplsRetirements.attributes.closure_date') || '-'}</b>
                </td>
              </tr>
            </React.Fragment>
          ) : null}
          <tr className="d-flex">
            <td width="350">
              <span className="title" style={{ fontSize: '16px' }}>
                BUSINESS INFORMATION AND REGISTRATION
              </span>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Business Identification Number (BIN)
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.bin') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Business Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.business_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Trade Name / Franchise (If Applicable)
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.trade_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Business Type
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.kind_of_ownership') || '-'}</b>
            </td>
          </tr>
          {get(data, 'attributes.sec_no') && (
            <tr>
              <td className="text-dark" width="250">
                SEC Registered Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.sec_no') || '-'}</b>
              </td>
            </tr>
          )}
          {get(data, 'attributes.dti_no') && (
            <tr>
              <td className="text-dark" width="250">
                DTI Registered Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.dti_no') || '-'}</b>
              </td>
            </tr>
          )}
          {get(data, 'attributes.dti_no') && (
            <tr>
              <td className="text-dark" width="250">
                DTI Registration Expiry Date
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{moment(get(data, 'attributes.dti_registration_expiry_date')).format('MM/DD/YYYY') || '-'}</b>
              </td>
            </tr>
          )}
          {get(data, 'attributes.cda_no') && (
            <tr>
              <td className="text-dark" width="250">
                CDA Registered Number
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>{get(data, 'attributes.cda_no') || '-'}</b>
              </td>
            </tr>
          )}
          <tr>
            <td className="text-dark" width="250">
              Taxpayer Identification Number (TIN)
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.tin_no') || '-'}</b>
            </td>
          </tr>
          <tr className="d-flex">
            <td width="350">
              <span className="title" style={{ fontSize: '16px' }}>
                CONTACT INFORMATION
              </span>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Email Address
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.email_address') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Mobile Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.cellphone_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Telephone Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.telephone_no') || '-'}</b>
            </td>
          </tr>
          <tr className="d-flex">
            <td width="350">
              <span className="title" style={{ fontSize: '16px' }}>
                {`${
                  ['ONE PERSON CORPORATION', 'PARTNERSHIP', 'CORPORATION'].indexOf(
                    get(data, 'attributes.kind_of_ownership')
                  ) > -1
                    ? "PRESIDENT/OFFICER-IN-CHARGE INFORMATION"
                    : "OWNER INFORMATION"
                } `}
              </span>
            </td>
          </tr>
          {get(
            data,
            'attributes.kind_of_ownership'
          ) === 'SOLE PROPRIETORSHIP' && (
            <tr>
              <td className="text-dark" width="350">
                Name of Owner
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {get(
                    data,
                    'attributes.owners_display_name'
                  ) || '-'}
                </b>
              </td>
            </tr>
          )}
          {get(
            data,
            'attributes.kind_of_ownership'
          ) === 'ONE PERSON CORPORATION' && (
            <tr>
              <td className="text-dark" width="350">
                Name of Owner
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {get(
                    data,
                    'attributes.owners_display_name'
                  ) || '-'}
                </b>
              </td>
            </tr>
          )}
          {(get(
            data,
            'attributes.kind_of_ownership'
          ) === 'CORPORATION' ||
            get(
              data,
              'attributes.kind_of_ownership'
            ) === 'COOPERATIVE' ||
            get(
              data,
              'attributes.kind_of_ownership'
            ) === 'PARTNERSHIP') && (
            <>
              <tr>
                <td className="text-dark" width="350">
                  Name of President / Officer In Charge
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>
                    {get(
                      data,
                      'attributes.owners_display_name'
                    ) || '-'}
                  </b>
                </td>
              </tr>
            </>
          )}
          <tr>
            <td className="text-dark" width="250">
              Sex
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.owners_gender') === "M" ? "MALE" : "FEMALE" || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Country of Citizenship
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.nationality_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Taxpayer&apos;s Address
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'attributes.display_address') || '-'}
              </b>
            </td>
          </tr>

          {/* <tr className="d-flex">
            <td>
              <span className="title" style={{ fontSize: '16px' }}>
                BUSINESS ADDRESS
              </span>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="350">
              Business Address
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>
                {get(
                  data,
                  'attributes.main_office_display_address'
                ) || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="350">
              Location Owned
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>
                {get(
                  data,
                  'attributes.location_owned'
                ) ? 'YES' : 'NO' || '-'}
              </b>
            </td>
          </tr>
          {get(data, 'attributes.location_owned') ? (
            <tr>
              <td className="text-dark" width="350">
                Tax Declaration No. or Property Identification No.
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {get(data, 'attributes.pin_no') ||
                    get(data, 'attributes.tdn_no')}
                </b>
              </td>
            </tr>
          ) : (
            <>
              <tr>
                <td className="text-dark" width="350">
                  Lessor Name
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>
                    {get(data, "attributes.lessor_name") || "--"}
                  </b>
                </td>
              </tr>
              <tr>
                <td className="text-dark" width="350">
                  Monthly Rental
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>
                    {get(data, "attributes.monthly_rental") || "--"}
                  </b>
                </td>
              </tr>
            </>
          )} */}

          <tr className="d-flex">
            <td width="350">
              <span className="title" style={{ fontSize: '16px' }}>
                BUSINESS OPERATIONS
              </span>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              <b>Business Area (sq.m)</b>
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.area') || 0}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              <b>Total Floor Area (sq.m)</b>
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.floor_area') || 0}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              <b>Total No. of Employees</b>
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_employees') || 0}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Male Employees
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_male_employees') || 0}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Female Employees
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_female_employees') || 0}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Employees Residing Area
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'attributes.no_of_employees_residing_manila') || 0}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              <b>Total No. of Vehicles</b>
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_vehicles') || 0}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Motorcycle
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_motorcycle') || 0}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Truck
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_truck') || 0}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Van
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_van') || 0}</b>
            </td>
          </tr>
          {Object.entries(detail).map(item => {
            return (
              <tr key={`bpls_business_detail${item[0]}`}>
                <td className="text-dark" width="250">
                  {ucwords(item[0].replace(/_/g, ' '))}
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>{item[1] || '-'}</b>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {!isEmpty(quantity_matrix) ? (
        Object.entries(quantity_matrix).map(([label, quantityMatrixData]) => {
          return (
            <React.Fragment>
              <div key={uuid()} className='text-dark text-capitalize mx-2' style={{ fontSize: '0.875rem'}}>
                {label || ''}
              </div>
              <div className='p-1'>
                <div className='w-100 border rounded-lg my-2'>
                  <table className="table table-borderless table-sm table-striped table-hover mb-0">
                    <thead>
                      <tr className='form-group'>
                        <td className='col-4 text-center form-label border-right'>Unit</td>
                        <td className='col-4 text-center form-label border-right'>Capacity</td>
                        <td className='col-4 text-center form-label'>Number of Units</td>
                      </tr>
                    </thead>
                    <tbody>
                      {quantityMatrixData.map(item => {
                          const multiplier = get(item, 'multiplier');

                          return (
                            <tr key={multiplier} className="top-border form-group">
                              <td className="text-left form-label border-right">
                                {get(item, 'unit')} 
                              </td>
                              <td className="text-left form-label border-right">
                                {get(item, 'capacity')}
                              </td>
                              <td className="text-left form-label">
                                {numberWithCommas(get(item, 'value', 0))}
                              </td>
                            </tr>
                          )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </React.Fragment>
          )
        })
      ) : ''}
      <table className="transaction-table table table-borderless table-sm">
        <tbody>
          <tr className="d-flex">
            <td>
              <span className="title" style={{ fontSize: '16px' }}>
                BUSINESS ACTIVITIES
              </span>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Activity Type
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.activity_type') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="350">
              Tax Incentives from any Government Entity
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>
                {get(
                  data,
                  'attributes.with_tax_incentives'
                ) ? 'YES' : 'NO'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Tax Incentives
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.tax_incentives_attachment_url') || '-'}</b>
            </td>
          </tr>
        </tbody>
      </table>

      <hr className="ct-hr" />
      <table className="w-100 transaction-table table table-borderless table-sm table-striped table-hover">
        <tbody>
          <tr />
          <tr className="">
            <td className="text-success" colSpan={3}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <b>REMARKS</b>
                {['NEW', 'RENEWAL', 'CHANGE'].indexOf(
                  get(remarks, 'attributes.transaction_type')
                ) > -1 &&
                  Acl(permissions, ['E2E BPLS REMARKS']) && (
                    <button
                      disabled={isLoading}
                      type="button"
                      onClick={handleAddRemarks(remarks)}
                      className="btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold   "
                    >
                      {isLoading ? (
                        <i className="fa fa-spin fa-spinner" />
                      ) : (
                        <>
                          {get(
                            remarks,
                            'included.bplsApplication.attributes.remarks'
                          )
                            ? 'Edit Remarks'
                            : 'Add Remarks'}
                        </>
                      )}
                    </button>
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={5}>
              <div className="w-100 my-2 p-2">
                <b className="text-wrap text-break">
                  {get(
                    remarks,
                    'included.bplsApplication.attributes.remarks'
                  ) || '--'}
                </b>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

BusinessInformation.defaultProps = {
  data: {},
};

BusinessInformation.propTypes = {
  data: PropTypes.instanceOf(Object),
  handleAddRemarks: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  remarks: PropTypes.instanceOf(Object).isRequired,
};

export default BusinessInformation;
